var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworksOpenIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.452,
    height: 32.438,
    viewBox: "0 0 37.452 32.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.031,
    y1: 0.766,
    x2: 1.042,
    y2: 0.179,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#f37d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#fbbf02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbf02"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3271",
    "data-name": "Groupe 3271",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M12.366,28.084a3.359,3.359,0,0,1,6.718-.008h0a3.358,3.358,0,0,1-3.354,3.362h0A3.359,3.359,0,0,1,12.366,28.084ZM21.26,26.01l0,0a3.36,3.36,0,0,1,4.755-4.748l0,0a3.358,3.358,0,0,1,0,4.748l0,0a3.358,3.358,0,0,1-4.748,0Zm-15.83,0,0,0a3.359,3.359,0,0,1,4.754-4.748l0,0a3.358,3.358,0,0,1,0,4.748l0,0a3.358,3.358,0,0,1-4.748,0Zm5.633-10.291a4.659,4.659,0,1,1,4.659,4.659A4.659,4.659,0,0,1,11.063,15.719Zm18.663,0a3.363,3.363,0,0,1,6.726,0v0a3.363,3.363,0,1,1-6.726,0ZM0,15.728a3.359,3.359,0,1,1,3.363,3.354h0A3.359,3.359,0,0,1,0,15.728Zm21.261-5.548,0,0a3.358,3.358,0,0,1,0-4.748l0,0a3.358,3.358,0,0,1,4.748,0l0,0a3.36,3.36,0,0,1-4.755,4.748Zm-15.831,0,0,0a3.358,3.358,0,0,1,0-4.748l0,0a3.358,3.358,0,0,1,4.748,0l0,0A3.36,3.36,0,0,1,5.43,10.181Zm6.929-6.818a3.358,3.358,0,1,1,3.363,3.355A3.358,3.358,0,0,1,12.359,3.362Z",
    transform: "translate(0 -0.001)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworksOpenIconColor);
export default __webpack_public_path__ + "static/media/networksOpenIconColor.8f4b9a34cd93ce70e7f66e84ade0c7fc.svg";
export { ForwardRef as ReactComponent };